/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/dashboard',
    icon: 'ActivityIcon',
    i18n: 'Dashboard'
  },
  {
    url: '/apps',
    icon: 'HomeIcon',
    i18n: 'Apps'
  },
  {
    url: '/devices',
    icon: 'CpuIcon',
    i18n: 'Devices'
  },
  {
    url: '/licenses',
    icon: 'KeyIcon',
    i18n: 'Licenses'
  },
  {
    url: '/organizations',
    icon: 'BriefcaseIcon',
    i18n: 'Companies'
  },
  {
    url: '/profiles',
    icon: 'ToolIcon',
    i18n: 'DeviceProfiles'
  },
  {
    url: '/types',
    icon: 'TagIcon',
    i18n: 'DeviceTypes'
  }
]
